// extracted by css-extract-rspack-plugin
export default {"entitiesSettingsPopup":"entitiesSettingsPopup__q8Xpi","grammarCodeView":"grammarCodeView__B3M8Y"};